import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles';
import configuration from './configuration';
import Index from './pages/IndexPage';
import PhotoGallery from './pages/PhotoGallery';
import VirtualTour from './pages/VirtualTour';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import Homes from './pages/Homes';
import HomeDetail from './pages/HomeDetail';
import PlanDetail from './pages/PlanDetail';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import ContactUsThankYou from './pages/ContactUs/ThankYou';
import NoRoute from './pages/NoRoute';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="RegionalSimple"
      components={[
        { override: 'Index', component: Index },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: NoRoute },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'photo-gallery', exact: true, path: '/photo-gallery', component: PhotoGallery },
        { name: 'virtual-tour', exact: true, path: '/virtual-tour', component: VirtualTour },
        { name: 'photo-gallery-filtered', exact: true, path: '/photo-gallery/:gallery', component: PhotoGallery, sitemapIgnore: true },
        { name: 'about-us', exact: true, path: '/about-us', component: AboutUs },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'contact-us-thank-you', exact: true, path: '/contact-us/thank-you', component: ContactUsThankYou, sitemapIgnore: true },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js